import axios from "axios";

const state = {
  provider_payments: [],
  loading: false,
  meta: {},
};

const getters = {
  providerPayments: (state) => state.provider_payments,
  loading: (state) => state.loading,
  meta: (state) => state.meta,
};

const actions = {
  getProviderPayments({ commit }, params = {}) {
    commit("setLoading", true);
    return axios
      .get(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/provider_payments`, {
        params,
      })
      .then((response) => {
        commit("setProviderPayments", response.data.data);
        commit("setMeta", response.data.meta);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createProviderPayment({ commit }, payload) {
    commit("setLoading", true);
    return axios
      .post(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/provider_payments`, payload)
      .finally(() => {
        commit("setLoading", false);
      });
  },

  updateProviderPayment({ commit }, payload) {
    commit("setLoading", true);
    return axios
      .put(
        `${process.env.VUE_APP_BACKEND_ROUTE}api/v2/provider_payments/${payload.id}`,
        payload
      )
      .finally(() => {
        commit("setLoading", false);
      });
  },

  deleteProviderPayment({ commit }, id) {
    commit("setLoading", true);
    return axios
      .delete(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/provider_payments/${id}`)
      .finally(() => {
        commit("setLoading", false);
      });
  },
};

const mutations = {
  setProviderPayments(state, data) {
    state.provider_payments = data;
  },
  setMeta(state, meta) {
    state.meta = meta;
  },
  setLoading(state, value) {
    state.loading = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
